import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ReviewStatus } from '../models/quality.models';

@Component({
  selector: 'app-review-status-control',
  standalone: true,
  imports: [
    CommonModule,
    MatButtonModule,
    MatCheckboxModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatTooltipModule,
  ],
  templateUrl: './review-status-control.component.html',
  styleUrls: ['./review-status-control.component.scss'],
})
export class ReviewStatusControlComponent {
  @Input() reviewStatus: ReviewStatus | undefined;
  @Input() reviewedBy?: string | null;
  @Input() reviewedAt?: string | null;
  @Input() loading = false;
  @Output() toggled = new EventEmitter<void>();

  get isComplete(): boolean {
    return this.reviewStatus === 'review-complete';
  }

  onToggle(event: Event): void {
    event.stopPropagation();
    this.toggled.emit();
  }
}
